import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for member invoices hooks
 * Keys match backend controller method names
 */
export const memberInvoicesKeys = {
  getMemberInvoices: (memberUuid: string, params?: QueryParamsDto) =>
    params
      ? (["member-invoices", memberUuid, "getMemberInvoices", params] as const)
      : (["member-invoices", memberUuid, "getMemberInvoices"] as const),
} as const
